import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { AmendsBoundaryButton } from "./amends-boundary-button"

export function AmendsBoundaryTaskButton() {
    const { task, target, getTaskAmendsKey } = useBoundContext()
    if (!getTaskAmendsKey) {
        throw new Error("AmendsBoundaryTaskButton requires getTaskAmendsKey")
    }

    const targetTask = target ?? task
    if (!targetTask) return null
    const amendsKey = getTaskAmendsKey(targetTask)
    if (!amendsKey) return null

    return <AmendsBoundaryButton amendsKey={amendsKey} />
}
